import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PaginatedTicketsDetails, TicketMessage, TicketsOverview } from '../Models/help&support';

@Injectable({
  providedIn: 'root'
})
export class HelpAndSupportService {
  constructor(private http:HttpClient) { }
  
    baseurl=`${environment.baseUrl}`

    getBookingOverview(filter:string = '') {

      return this.http.get<TicketsOverview>(`${this.baseurl}/ticket/tickets-overview?filter=${encodeURIComponent(filter)}`);
    }

getAllOpenTickets(
  searchText: string = '',
  raisedDateFilter: string = '',
  isClosed: boolean = false,
  pageNumber: number = 1,
  pageSize: number = 10
) {
  const url = `${this.baseurl}/ticket/tickets` +
    `?searchText=${encodeURIComponent(searchText)}` +
    `&raisedDateFilter=${encodeURIComponent(raisedDateFilter)}` +
    `&isClosed=${isClosed}` +
    `&pageNumber=${pageNumber}` +
    `&pageSize=${pageSize}`;

  return this.http.get<PaginatedTicketsDetails>(url);

}

closeTicket(ticketId: number  ,closedBy:number) {
  return this.http.put(`${this.baseurl}/ticket/close-ticket?ticketActivityId=${ticketId}&closedBy=${closedBy}`,{});  
}

DeleteTicket(ticketId: number,deletedby:number) {
  // Ensure the ticketId and deletedby ar
  return this.http.delete(`${this.baseurl}/ticket/delete-ticket?ticketActivityId=${ticketId}&deletedBy=${deletedby}`);  
}
getChatHistory(ticketId: number) {
  return this.http.get<TicketMessage[]>(`${this.baseurl}/ticket/ticket-chat-history?ticketActivityId=${ticketId}`);

}


}